import React from 'react';

const Back = () => {
    return (
        <svg width="18.267" height="18.267" viewBox="0 0 18.267 18.267">
            <g id="Group_918" data-name="Group 918" transform="translate(-1093.867 -739)">
                <g id="Icon_feather-arrow-right-circle" data-name="Icon feather-arrow-right-circle" transform="translate(1094.867 740)">
                <path id="Path_759" data-name="Path 759" d="M3,11.133A8.133,8.133,0,1,0,11.133,3,8.133,8.133,0,0,0,3,11.133Z" transform="translate(-3 -3)" fill="none" stroke="#231f20" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <path id="Path_760" data-name="Path 760" d="M21.253,18.507,18,15.253,21.253,12" transform="translate(-13.12 -7.12)" fill="none" stroke="#231f20" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <path id="Path_761" data-name="Path 761" d="M18.507,18H12" transform="translate(-7.12 -9.867)" fill="none" stroke="#231f20" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                </g>
            </g>
        </svg>
    );
};

export default Back;